import { SelectListItemModel } from './../models/select-list-item.model';
import { AppSettings } from './../app-settings';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/shareReplay';
import { EnrollmentProgramModel } from './../models/enrollment-program.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProgramStatementsModel } from '../models/program-statements.model';
import { StudentPayrollRequest } from "app/shared/models/payment-method-select.model";
import { InstitutionsInfoModel } from "app/shared/models/instituitions-info.model";
import { EnrolleeAddress } from "app/shared/models/enrollee-address.model";
import { ActiveProviderModel } from "app/shared/models/active-provider.model";

@Injectable()
export class EnrollmentProgramsService {

  constructor(private http:HttpClient) {

  }

  private _programs:any;
  private _currentProgram:EnrollmentProgramModel; 

  getCurrentProgram():EnrollmentProgramModel{
    return this._currentProgram;
  }

  getEnrolleePrograms():Observable<EnrollmentProgramModel[]>{ 
    if(!this._programs)
        this._programs= this.http.get<EnrollmentProgramModel[]>(AppSettings.endpoints.system.programs).shareReplay(1);
    return this._programs;
  }
  
  getActiveProviders(alias:string):Observable<ActiveProviderModel[]>{ 
    let url=AppSettings.formatUrl(AppSettings.endpoints.system.getActiveProviders,alias);
    var providers = this.http.get<ActiveProviderModel[]>(url);
    return providers;
  }

  getEnrolleProgramByAlias(alias:string):Observable<EnrollmentProgramModel>{    
    
    return this.getEnrolleePrograms()
    .map((data)=>{
      this._currentProgram = data.find((i)=>i.programAlias==alias);
      return this._currentProgram;
    });
  }

  getBackgroundImageUrl(alias:string):Observable<string>{
   return this.getEnrolleProgramByAlias(alias).map(i=>{
      return `${AppSettings.blobsStorage}/${i.backgroundImgId}`;
    })
  }


  private statementsObservRef:Observable<ProgramStatementsModel>;
  private enrollmentProgAlias:string;
  getProgramStatements(alias:string):Observable<ProgramStatementsModel>{
    if(!this.statementsObservRef || this.enrollmentProgAlias!=alias){
      let url=AppSettings.formatUrl(AppSettings.endpoints.system.statements,alias);
      this.statementsObservRef=this.http.get<ProgramStatementsModel>(url).shareReplay(1);
      this.enrollmentProgAlias=alias;
    }      
    return this.statementsObservRef;
  }

  getDebitCardAckStatement(): Observable<string>{
    if(!this.statementsObservRef)
      return Observable.of('')
    return this.statementsObservRef.map(i =>i.debitCardFeeAcknowledgement);
  }

  getLoginStatementBefore():Observable<string>{
    if(!this.statementsObservRef)
      return Observable.of('')
    return this.statementsObservRef.map(i=>i.loginStatementBefore);
  }

  getCutOffMessage():Observable<string>{
    if(!this.statementsObservRef)
    return Observable.of('')
  return this.statementsObservRef.map(i=>i.loginStatementAppCutoffMsg);
  }

  getSubmissionMessage():Observable<string>{
    if(!this.statementsObservRef)
      return Observable.of('');
    return this.statementsObservRef.map(i=>i.submissionMsg);
  }

  getThankYouMessage():Observable<string>{
    if(!this.statementsObservRef)
    return Observable.of('')
  return this.statementsObservRef.map(i=>i.thankYouMsg);
  }

  getFileUploadMessage():Observable<string>{
    if(!this.statementsObservRef)
      return Observable.of('');
    return this.statementsObservRef.map(i => i.fileUploadMsg);
  }

  getPaymentMethodMessage():Observable<string>{
    if(!this.statementsObservRef)
      return Observable.of('');
    return this.statementsObservRef.map(i => i.paymentMethodSelectMsg)
  }

  getIsLoginHidden():Observable<boolean>{
    if(!this.statementsObservRef)
    return Observable.of(false)
  return this.statementsObservRef.map(i=>i.isLoginHidden);
  }

  getIsRegisterHidden():Observable<boolean>{
    if(!this.statementsObservRef)
    return Observable.of(false)
  return this.statementsObservRef.map(i=>i.isRegisterHidden);
  }

  getOpportunityStatement():Observable<string>{
    if(!this.statementsObservRef)
    return Observable.of('')
  return this.statementsObservRef.map(i=>i.eqOpportunityErStatement);
  }

  getIsReferralCodeRequired():Observable<boolean>{
    if(!this.statementsObservRef)
    return Observable.of(false)
  return this.statementsObservRef.map(i=>i.isReferralCodeRequired);
  }

  getIsRestricted():Observable<boolean>{
    if(!this.statementsObservRef)
    return Observable.of(false)
  return this.statementsObservRef.map(i=>i.isRestricted);
  }

  getProgramEmail():Observable<string>{
    if(!this._currentProgram)
      return Observable.of('');
    return Observable.of(this._currentProgram.programEmail);
  }

  getPaymentSelectExpirationDate(): Observable<Date>{
    if(!this._currentProgram || this._currentProgram.paymentSelectCutoffDate == null){
      var currentYear = new Date().getFullYear().toString();
      var baseProgramDate = new Date(`${currentYear}-07-30`);
      return Observable.of(new Date(baseProgramDate))
    }
  return Observable.of(this._currentProgram.paymentSelectCutoffDate)
  }

  getPaymentMethodsLookup(): Observable<SelectListItemModel[]> {
    return this.http.get<SelectListItemModel[]>(AppSettings.endpoints.enrollees.paymentMethodsLookupValues).shareReplay(1);
  }

  getBankList(bankName?): Observable<InstitutionsInfoModel[]> {
    return this.http.get<InstitutionsInfoModel[]>(AppSettings.formatUrl(AppSettings.endpoints.enrollees.bankList, bankName));
  }
}

@Injectable()
export class EnrollmentService{
  constructor(private http:HttpClient) {

  }

  getEnrolleePaymentMethod(enrolleeId: number){
    return this.http.get<StudentPayrollRequest>(AppSettings.formatUrl(AppSettings.endpoints.enrollees.getStudentPayrollMethod, enrolleeId));
  }

  getEnrolleeAddress(enrolleeId: number): Observable<EnrolleeAddress>{
    return this.http.get<EnrolleeAddress>(AppSettings.formatUrl(AppSettings.endpoints.enrollees.enrolleeAddress, enrolleeId));
  }

  addPayrollMethod(model: StudentPayrollRequest):Observable<any>{
    var url = AppSettings.endpoints.enrollees.addPaymentMethod;
    return this.http.post(url, model, AppSettings.EMPTY_REQUEST_OPTIONS);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/enrollment-programs.service.ts